// import Joi from 'joi-browser';
import HttpService from '@pingum/api-services/HttpService';

export default class TagsService {
  static deleteSchedulesByTagId(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Tag ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}/schedules`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static getTagReminders(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Tag ID'));
    }

    return this.httpService.get(`/${id}/tagReminders`);
  }
}

TagsService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_EVENT_API
    : ''}/tags`,
});
